import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import useAppGlobal from "src/context/useAppGlobal";
import useProviderAction from "src/pages/setting/provider/utils/useProviderAction";
import useProviderBody from "src/pages/setting/provider/utils/useProviderBody";
import { providerSelectList } from "./utils/constant";
import { Add } from "@mui/icons-material";
import ProviderCreate from "./ProviderCreate";
import TabComp from "src/components/shared/TabComp";
import useAuthGlobal from "src/context/useAuthGlobal";
import useRedirect from "src/helper/direct";
import { CHECK_RETURN_PROD_STATUS } from "src/constant";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function ProviderTable() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const { userMe } = useAuthGlobal();
  const redirect = useRedirect();

  useEffect(() => {
    if (userMe?.warehouse?.type === CHECK_RETURN_PROD_STATUS.normal) {
      redirect("/home");
    }
  }, [redirect, userMe?.warehouse?.type]);
  const [sumWhouseId, setSumWHouseId] = useState();
  const [searchBy, setSearchBy] = useState();
  const [keyword, setKeyword] = useState();
  const action = useProviderAction();
  const { header, bodyList, sortData, total } = useProviderBody({
    searchBy,
    keyword,
    providerSelectList,
  });

  const handleCreateProvider = () => {
    handleOpenDialog({
      title: "Thêm nhà cung cấp",
      size: "md",
      content: <ProviderCreate />,
    });
  };
  return (
    <React.Fragment>
      <PageHeader
        name="Quản lý Nhà cung cấp"
        subName="Nhà cung cấp"
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
      <Stack
        gap={1.5}
        my={1.5}
      >
        <Button
          disabled={!permissionCheck([PERMISSIONS.CREATE_PROVIDER])}
          onClick={handleCreateProvider}
          variant="contained"
          startIcon={<Add />}
          sx={{ width: "220px" }}
        >
          Thêm nhà cung cấp
        </Button>
        <TabComp tabs={[{ id: "providers", name: "Nhà cung cấp" }]} />
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
          maxWidth="300px"
        >
          <SearchFilterComp
            selectList={providerSelectList}
            getSearchKeyword={setKeyword}
            getSelectKeyword={setSearchBy}
            placeholder="Tìm kiếm Nhà cung cấp..."
          />
        </Box>
        <Typography sx={{ fontWeight: "bold" }}>{total < 10 ? "0" + total : total} nhà cung cấp </Typography>
      </Stack>

      <TableComp
        dynamicWidth={"850px"}
        headers={header}
        sortData={sortData}
        bodyList={bodyList}
        action={action}
      />
    </React.Fragment>
  );
}
